import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, Renderer2, effect, inject } from '@angular/core';

import { LoaderService } from '@services/loader.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent implements OnDestroy {
  private readonly renderer = inject(Renderer2);
  readonly loaderService = inject(LoaderService);

  constructor() {
    /*
     * Reacts to the isLoading signal and toggles a `loading` CSS class on the document body,
     * which can be used to prevent scrolling or dim the page while a request is in-flight.
     */
    effect(() => {
      if (this.loaderService.isLoading()) {
        this.renderer.addClass(document.body, 'loading');
      } else {
        this.renderer.removeClass(document.body, 'loading');
      }
    });
  }

  /*
   * Lifecycle hook — ensures the `loading` class is removed from the body if the component
   * is destroyed while a request is still in-flight, preventing a permanently locked UI.
   */
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'loading');
  }
}
